import React from 'react'
import moize from 'moize'
import { connect } from 'react-redux'
import { Route, Switch } from 'wouter'
import LazyLoad from './services/lazy-load'
import { formMetaData } from '.'
import useMountEffect from './hooks/useMountEffect'
import { removeInitialValues } from './util/storageManager'
import { removeCustomCss } from './components/FormRenderer/formRendererUtil.js'

const Form = LazyLoad({ loader: () => import('./pages/form') }, true)
const Root = LazyLoad({ loader: () => import('./pages') })
const AnswersSheet = LazyLoad(
  { loader: () => import('./pages/answer-sheet') },
  true
)

const interfaceRoutes = [
  {
    path: '/',
    Component: Root,
    key: 'root',
  },
  {
    path: '/:formAddress/answer-sheet/:submitCode',
    Component: AnswersSheet,
    key: 'answerSheet',
  },
  {
    path: '/:formAddress',
    exact: true,
    Component: Form,
    key: 'formView',
  },
]

const unmountTheApp = () => {
  /* clear sessionStorage */
  removeInitialValues()
}

const App = () => {
  useMountEffect(() => {
    window.addEventListener('beforeunload', unmountTheApp)
    return () => {
      window.removeEventListener('beforeunload', unmountTheApp)
      removeCustomCss()
    }
  })

  // if the form is embedded, there is no need to use routing, so just render the form directly
  const isFormEmbeddedScript = Boolean(formMetaData.slug)
  if (isFormEmbeddedScript) return <Form />

  return (
    <Switch>
      {interfaceRoutes.map(({ Component, ...route }) => (
        <Route {...route}>{(params) => <Component {...params} />}</Route>
      ))}
    </Switch>
  )
}

export default connect()(moize(App), { isReact: true })
